import * as React from "react";
import {
    Backdrop,
    Box,
    Typography,
    Stack
} from "@mui/material";
import LockRoundedIcon from "@mui/icons-material/LockRounded";

const SubscriptionInactiveBackdrop = ({open}) => {
    return (
        <Backdrop
            open={open}
            sx={{
                zIndex: (theme) => theme.zIndex.drawer + 1,
                color: "#fff",
                backdropFilter: "blur(2px)"
            }}
        >
            <Box
                sx={{
                    backgroundColor: "background.paper",
                    color: "#478A64",
                    p: 4,
                    borderRadius: 2,
                    maxWidth: 420,
                    textAlign: "center",
                    boxShadow: 6
                }}
            >
                <Stack spacing={2} alignItems="center">
                    <LockRoundedIcon color="primary" sx={{ fontSize: 48, color: '#478A64' }} />

                    <Typography variant="h6">
                        Az előfizetés nem aktív
                    </Typography>

                    <Typography variant="body2" color="text.secondary">
                        A funkció használatához aktív előfizetés szükséges.
                    </Typography>

                </Stack>
            </Box>
        </Backdrop>
    );
};

export default SubscriptionInactiveBackdrop;
